import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { ICE_GSM_INSTRUMENT_BASE_PATH } from '../../../../../../../../../features/vendor/ice/global-security-master/instrument/ice-gsm-instrument-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/instrument/_instrument')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'ice-gsm-instrument-list',
        label: 'ICE',
        to: ICE_GSM_INSTRUMENT_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
